import { startCase } from "lodash";
import { TAG_TYPE_DISPLAY_NAME } from "../constants";

const getTagTypeDisplayName = (tagType) => TAG_TYPE_DISPLAY_NAME[tagType] || startCase(tagType);

export default getTagTypeDisplayName;
